import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import React, { Component } from 'react';
import Avatar from '@mui/material/Avatar';
import Chip from '@mui/material/Chip';
import { R_FOR } from '@lba-dev/package.local-globals/remStatus';
import { getByKey } from '@lba-dev/package.local-globals/aSecurity';
import { red } from '@mui/material/colors';

import { formatDate } from '../../../utils/date';
import Money from '../../../utils/Money/Money';
import { GetDoc } from '../../../utils/function';
import { commentView } from './Components/Comments';
import { Graphic as graphicData } from '../../../views/RecapArtisan/Graphic';
import DialogsRecap from '../../../views/recapArtisan/DialogsRecap';

const styles = {
  padding: {
    padding: '12px',
  },
  fontColor: {
    color: 'black',
  },
  fontAbbr: { fontSize: '0.750rem' },
  ctnDoc: { width: '86%', marginTop: 30 },
  chip: {
    flexDirection: 'row-reverse',
    fontWeight: 'bold',
    margin: 5,
  },
  marginBotCtr: { marginBottom: 25 },
  comment: {
    wordBreak: 'break-word',
  },
  uList: {
    padding: 0,
    margin: '0 15px',
  },
  ctnType: {
    marginTop: 15,
    display: 'inline',
  },
  ctnGenSection: {
    padding: '20px 20px 10px',
  },
  ctnComment: {
    padding: '0 10px 12px',
  },
};

const getRenum = (artisan) => {
  let type,
    chip = '';
  if (artisan.remuneration.status === R_FOR) {
    type = 'Forfait';
  } else {
    type = 'Pourcentage';
    chip = (
      <Chip
        style={styles.chip}
        avatar={<Avatar>%</Avatar>}
        color="primary"
        label={artisan.remuneration.pourcentage.labor}
        variant="outlined"
      />
    );
  }
  return (
    <div style={styles.ctnType}>
      <Typography variant="subtitle1" style={{ marginTop: 30 }}>
        {type}
      </Typography>
      {chip}
    </div>
  );
};

const generateSection = (title, func, props) => (
  <Grid item {...props} style={{ textAlign: 'center' }}>
    {func}
  </Grid>
);

class ArtisanMenu extends Component {
  state = {
    dialogName: '',
  };

  setDialogName = (dialogName = '') => this.setState({ dialogName });

  closeDialog = () => this.setDialogName();

  render() {
    const { elem, users } = this.props;
    const { dialogName } = this.state;
    const block = getByKey({ artisan: elem });
    return (
      <React.Fragment>
        <Grid container style={styles.marginBotCtr}>
          {generateSection(
            'Commentaire',
            commentView({ artisan: elem, users, limit: 5 }),
            {
              xs: 3,
            }
          )}
          {generateSection(
            'Artisan',
            graphicData({ intervention: elem.intervention }),
            { xs: 3 }
          )}

          <Grid container item xs={3}>
            {generateSection('Rémunération', false, { xs: 12 })}
            {elem && elem.remuneration && (
              <Grid item xs={12} style={{ textAlign: 'center' }}>
                <Typography variant="h3" style={styles.fontColor}>
                  {elem.intervention
                    ? Money.toString(elem.intervention.totalGain)
                    : '0'}{' '}
                  €
                </Typography>
                <Typography variant="subtitle1">
                  {elem.date &&
                    `Gains depuis le ${formatDate(new Date(elem.date.ajout))}`}
                </Typography>

                <Typography variant="h3" style={styles.fontColor}>
                  0 €
                </Typography>
                <Typography variant="subtitle1">
                  Chiffre d'affaire
                  <div style={styles.fontAbbr}>
                    (représente la totalité des montants)
                  </div>
                </Typography>
                {getRenum(elem)}
              </Grid>
            )}
          </Grid>
          {generateSection(
            'Document',
            <Grid item style={styles.ctnDoc}>
              <GetDoc
                artisan={elem}
                handleGetDoc={(e) =>
                  this.setDialogName(e.currentTarget.dataset.title)
                }
              />
              {block && (
                <Typography variant={'subtitle1'} style={{ color: red[500] }}>
                  Bloqué: {block.name}
                </Typography>
              )}
            </Grid>,
            { xs: 3 }
          )}
        </Grid>
        <DialogsRecap
          viewDialog={dialogName}
          paramsDialog={{ dialogTitle: dialogName, stateDialog: !!dialogName }}
          artisan={elem}
          handleCloseDialog={this.closeDialog}
          parentProps={{ users }}
        />
      </React.Fragment>
    );
  }
}

export default ArtisanMenu;
